import gql from "graphql-tag";
import ProjectWasteMappingFragment from "../fragments/ProjectWasteMappingFragment";

const UpsertProjectWasteMapping = gql`
  mutation UpsertProjectWasteMapping($objects: [projectWasteMapping_insert_input!]!) {
    insert_projectWasteMapping(
      objects: $objects
      on_conflict: {
        constraint: project_material_waste_mapping_pkey
        update_columns: [
          label
          materialId
          materialWasteTypeId
          pickupDate
          projectId
          customWeight
          projectWasteTypeCustomId
          materialWeightSnapshot
        ]
      }
    ) {
      affected_rows
      returning {
        ...projectWasteMapping
      }
    }
  }
  ${ProjectWasteMappingFragment}
`;

export default UpsertProjectWasteMapping;
